import React from 'react';
import PropTypes from 'prop-types';
import clsx from "clsx";
import {PreviewIcon, TrashIcon} from "presentation/common/components/style-guide/icons";
import {emptyFn, showFile} from "presentation/common/helpers/utils";
import ReactTooltip from "react-tooltip";
import {DefaultOption} from "presentation/common";
import {billType} from "application/globals/new-request.data";
import {Field} from "formik";
import Select from "react-select";

import styles from './FilesTable.module.scss';

export const FilesTable = (props) => {
  const {files, onDeleteFile} = props;

  return (
    <>
      <ReactTooltip id='deleteTooltip' type='info' effect='solid' backgroundColor="var(--primary)">
        Eliminar
      </ReactTooltip>

      <ReactTooltip id='previewTooltip' type='info' effect='solid' backgroundColor="var(--primary)">
        Ver documento
      </ReactTooltip>

      <div className="flex flex-col mt-4">
        <div className="-my-2 overflow-hidden sm:-mx-6 lg:-mx-8">
          <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
            <div className="overflow-hidden border border-gray-300 sm:rounded-lg">
              <table className={clsx("min-w-full divide-y divide-gray-200", styles.table)}>
                <thead className="bg-gray-50">
                <tr>
                  <th scope="col"
                      className="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Nombre
                  </th>
                  <th
                    scope="col"
                    className="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Tipo documental
                  </th>
                  <th scope="col"
                      className="px-1 py-3 lg:px-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider text-right">
                  </th>
                </tr>
                </thead>
                <tbody>
                {
                  files.map((file, index) => {
                    return (
                      <tr className={clsx("bg-white text-center")} key={file.id}>
                        <td
                          className={clsx("text-left pl-2 py-2 whitespace-nowrap text-sm font-medium", styles.cell, styles.fileName)}>
                          {file.file.name}
                        </td>
                        <td
                          className={clsx("text-left px-2 py-2 whitespace-nowrap text-sm", styles.cell, styles.fileType)}>

                          <Field name={`files.${index}.type`}>
                            {({meta, field}) => {
                              return (
                                <Select
                                  isClearable
                                  options={billType}
                                  name={`files.${index}.type`}
                                  placeholder="Seleccione"
                                  classNamePrefix="react-select"
                                  components={{Option: DefaultOption}}
                                  menuPortalTarget={document.body}
                                  instanceId={`files.${index}.type`}
                                  value={{value: meta.value, label: meta.value}}
                                  className={clsx('react-select-container', {'is-invalid': meta.touched && meta.error})}
                                  onChange={option => {
                                    field.onBlur?.({
                                      target: {name: field.name},
                                    })

                                    field.onChange({
                                      target: {name: field.name, value: option?.value || ''},
                                    })
                                  }}
                                  onBlur={() => {
                                    field.onBlur?.({
                                      target: {name: field.name},
                                    })
                                  }}
                                />
                              )
                            }}
                          </Field>
                        </td>
                        <td
                          className={clsx("px-1 py-2 lg:px-3 text-sm text-gray-500 text-right")}>
                          <button onClick={() => showFile(file.file)} data-tip data-for='previewTooltip' className="hidden lg:inline">
                            <PreviewIcon className={clsx("cursor-pointer mr-1 -mt-1", styles.icon)}/>
                          </button>
                          <button onClick={() => onDeleteFile(file)} data-tip data-for='deleteTooltip'>
                            <TrashIcon className={clsx("cursor-pointer", styles.icon)}/>
                          </button>
                        </td>
                      </tr>
                    )
                  })
                }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

FilesTable.propTypes = {
  files: PropTypes.array,
  onDeleteFile: PropTypes.func
}

FilesTable.defaultProps = {
  files: [],
  onDeleteFile: emptyFn
}

export default FilesTable;
